import Router from './shared/Router';

function App(): JSX.Element {
  return <Router></Router>;
}

export default App;
